import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';

const CreateServiceModal = ({ show, handleClose }) => {
  const [newService, setNewService] = useState({
    type_id: '',
    name: '',
    price: '',
    duration: '',
    description: '',
    active: false
  });
  const [serviceTypes, setServiceTypes] = useState([]);

  const getServicesTypes = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/services/getServicesTypes`)
      .then(response => {
        setServiceTypes(response.data);
      })
      .catch(error => {
        console.error(error);
      });
  };

  useEffect(() => {
    getServicesTypes();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewService(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleTypeChange = (e) => {
    const typeId = e.target.value;
    setNewService(prevState => ({
      ...prevState,
      type_id: typeId
    }));
  };

  const handleSubmit = () => {
    // Aquí puedes enviar los datos del nuevo servicio al servidor
    console.log("Nuevo servicio:", newService);

    axios.post(`${process.env.REACT_APP_API_URL}/services/createService`, newService)
      .then(response => {
        console.log("Service updated successfully:", response.data.message);
        setNewService({
            type_id: '',
            name: '',
            price: '',
            duration: '',
            description: '',
            active: false
          });
        handleClose();
      })
      .catch(error => {
        console.error("Error updating service:", error);
        handleClose();
      });
    // Después de enviar los datos, cierra el modal
    
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Crear nuevo servicio</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="mb-3">
            <label htmlFor="type" className="form-label">Tipo:</label>
            <select className="form-control" id="type" name="type_id" value={newService.type_id} onChange={handleTypeChange}>
              <option value="">Seleccionar tipo</option>
              {serviceTypes.map(type => (
                <option key={type.id} value={type.id}>{type.name}</option>
              ))}
            </select>
          </div>
          <div className="mb-3">
            <label htmlFor="name" className="form-label">Nombre:</label>
            <input type="text" className="form-control" id="name" name="name" value={newService.name} onChange={handleChange} />
          </div>
          <div className="mb-3">
            <label htmlFor="price" className="form-label">Precio:</label>
            <input type="number" className="form-control" id="price" name="price" value={newService.price} onChange={handleChange} />
          </div>
          <div className="mb-3">
            <label htmlFor="duration" className="form-label">Duración:</label>
            <input type="number" className="form-control" id="duration" name="duration" value={newService.duration} onChange={handleChange} />
          </div>
          <div className="mb-3">
            <label htmlFor="description" className="form-label">Descripción:</label>
            <textarea className="form-control" id="description" name="description" value={newService.description} onChange={handleChange}></textarea>
          </div>
          <div className="mb-3 form-check">
            <input type="checkbox" className="form-check-input" id="active" name="active" checked={newService.active} onChange={() => setNewService(prevState => ({ ...prevState, active: !prevState.active }))} />
            <label className="form-check-label" htmlFor="active">Activo</label>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateServiceModal;
